<template>
  <!-- <div
    ref="backToTopElement"
    v-show="isVisible"
    class="backtotop-wrap cursor-pointer"
    @click="scrollToTop"
  >
    <svg class="backtotop-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
      <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
    </svg>
    <svg class="backtotop-arrow" width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7224 7.53586C14.1134 7.15399 14.1134 6.53485 13.7224 6.15297L7.7157 0.285907C7.32476 -0.0959421 6.69086 -0.0959422 6.29992 0.285907L0.293223 6.15297C-0.0977134 6.53485 -0.0977134 7.15398 0.293222 7.53586C0.684158 7.91773 1.31807 7.91773 1.709 7.53586L7.00781 2.36021L12.3066 7.53586C12.6976 7.91773 13.3314 7.91773 13.7224 7.53586Z" fill="white"/>
    </svg>
  </div> -->
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'

const isVisible = ref(false)
const backToTopElement = ref<HTMLElement | null>(null)
const progressPath = ref<SVGPathElement | null>(null)

const scrollToTop = () => {
  // Smooth scroll to top
  const startPosition = window.pageYOffset
  const targetPosition = 0
  const distance = targetPosition - startPosition
  const duration = 550
  const startTime = performance.now()
  
  function animate(currentTime: number) {
    const elapsed = currentTime - startTime
    const progress = Math.min(elapsed / duration, 1)
    
    // Easing function (ease-in-out)
    const ease = progress < 0.5
      ? 2 * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 2) / 2
    
    window.scrollTo(0, startPosition + distance * ease)
    
    if (progress < 1) {
      requestAnimationFrame(animate)
    }
  }
  
  requestAnimationFrame(animate)
}

const handleScroll = () => {
  const scroll = window.scrollY || window.pageYOffset
  isVisible.value = scroll > 150
  
  // Update SVG path progress if element exists
  if (progressPath.value) {
    const pathLength = progressPath.value.getTotalLength()
    const height = document.documentElement.scrollHeight - window.innerHeight
    const progress = pathLength - (scroll * pathLength) / height
    progressPath.value.style.strokeDashoffset = String(progress)
    
    // Toggle active class
    if (backToTopElement.value) {
      if (scroll > 150) {
        backToTopElement.value.classList.add('active-progress')
      } else {
        backToTopElement.value.classList.remove('active-progress')
      }
    }
  }
}

onMounted(() => {
  // Initialize SVG path if it exists
  if (backToTopElement.value) {
    const path = backToTopElement.value.querySelector('path') as SVGPathElement
    if (path) {
      progressPath.value = path
      const pathLength = path.getTotalLength()
      path.style.transition = 'none'
      path.style.strokeDasharray = `${pathLength} ${pathLength}`
      path.style.strokeDashoffset = String(pathLength)
      path.getBoundingClientRect() // Force reflow
      path.style.transition = 'stroke-dashoffset 10ms linear'
    }
  }
  
  window.addEventListener('scroll', handleScroll, { passive: true })
  handleScroll() // Initial call
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
.backtotop-wrap {
  position: fixed;
  bottom: 30px;
  right: 30px;
  height: 46px;
  width: 46px;
  cursor: pointer;
  display: block;
  border-radius: 50px;
  z-index: 100;
  opacity: 0;
  visibility: hidden;
  transform: translateY(20px);
  transition: all 400ms linear;
  background: var(--color-primary);
}

@media (max-width: 575px) {
  .backtotop-wrap {
    bottom: 20px;
    right: 20px;
  }
}

.backtotop-wrap.active-progress {
  opacity: 1;
  visibility: visible;
  transform: translateY(0px);
}

.backtotop-arrow {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  pointer-events: none;
}

.backtotop-arrow path {
  fill: white;
}

.backtotop-wrap svg.backtotop-circle path {
  fill: none;
  stroke: #ccc;
  stroke-width: 0;
  box-sizing: border-box;
  transition: all 400ms linear;
}
</style>

